import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbButtonModule, NbCardModule, NbCheckboxModule, NbDatepickerModule, NbDialogModule, NbActionsModule, NbRadioModule, NbFormFieldModule, NbIconModule, NbInputModule, NbListModule, NbSelectModule, NbToastrModule } from '@nebular/theme';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExternsRoutingModule } from './externs-routing.module';
import { ListExternsComponent } from './list/list.component';
import { DeleteExternComponent } from './delete/delete.component';
import { EditExternComponent } from './edit/edit.component';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { ShowExternComponent } from './show/show.component';
import { SearchCompanyComponent } from './search-company/search-company.component';
import { SearchExternComponent } from './search-extern/search-extern.component';



@NgModule({
    declarations: [
        ListExternsComponent,
        EditExternComponent,
        DeleteExternComponent,
        ShowExternComponent,
        SearchCompanyComponent,
        SearchExternComponent
    ],
    imports: [
        CommonModule,
        ExternsRoutingModule,
        NbIconModule,
        NbButtonModule,
        NbActionsModule,
        NbCardModule,
        NbCheckboxModule,
        NbListModule,
        NbDialogModule.forChild(),
        NbToastrModule,
        ReactiveFormsModule,
        NbRadioModule,
        FormsModule,
        NbDatepickerModule,
        NbFormFieldModule,
        NbDateFnsDateModule,
        NbInputModule,
        NbSelectModule,
    ]
})
export class ExternsModule { }
